/* eslint-disable */
import VARS from './vars'
import { getStatusBarHeight, StatusBarRes } from './sdk'
import { setPicSize } from '@zz-common/zz-utils'

const toRealPx = function (pt) {
  return (pt / 750) * document.documentElement.getBoundingClientRect().width
}

export default {
  install(Vue, options) {
    Vue.directive('ios-status-bar-padding', {
      bind(el, binding, vnode, oldVnode) {
        let paddingTop = '0'
        getStatusBarHeight((res: StatusBarRes) => {
          if (res.code === '0') {
            paddingTop = res.height + 'px'
          } else {
            if (VARS.isIOS) {
              paddingTop = VARS.isIphoneX ? '44px' : '24px'
            }
          }
          el.style.paddingTop = paddingTop
        })
      }
    }),
      // iOS 状态栏加上导航栏padding-top 高度
      Vue.directive('ios-status-bar-padding-nav-bar', {
        bind(el, binding, vnode, oldVnode) {
          let paddingTop = '0'
          if (VARS.isWx) {
            el.style.paddingTop = paddingTop
          } else {
            getStatusBarHeight((res: StatusBarRes) => {
              if (res.code === '0') {
                paddingTop = res.height + 44 + 'px'
              } else {
                if (VARS.isIOS) {
                  paddingTop = VARS.isIphoneX ? '88px' : '68px'
                } else {
                  // Android 导航条高度
                  paddingTop = '44px'
                }
              }
              el.style.paddingTop = paddingTop
            })
          }
        }
      }),
      Vue.directive('ios-status-bar-margin', {
        bind(el, binding, vnode, oldVnode) {
          let marginTop = '0'
          getStatusBarHeight((res: StatusBarRes) => {
            if (res.code === '0') {
              marginTop = res.height + 'px'
            } else {
              if (VARS.isIOS) {
                marginTop = VARS.isIphoneX ? '44px' : '24px'
              }
            }
            el.style.marginTop = marginTop
          })
        }
      }),
      Vue.directive('ios-x-bottom-margin', {
        bind(el, bind, vnode, oldVnode) {
          const offset = bind.value || 0
          let height = '0'
          const vm = vnode.context
          if (VARS.isIOS) {
            height = VARS.isIphoneX ? `${32 + offset}px` : `${offset}`
          }
          el.style.marginBottom = height
        }
      }),
      Vue.directive('ios-x-bottom-padding', {
        bind(el, bind, vnode, oldVnode) {
          const offset = bind.value || 0
          let height = '0'
          const vm = vnode.context
          if (VARS.isIOS) {
            height = VARS.isIphoneX ? `${32 + offset}px` : `${offset}`
          }
          el.style.paddingBottom = height
        }
      })

    // v-background指令
    // 使用方法：v-background:image="{src: picUrl, width : 24, height: 24}"
    Vue.directive('background', {
      componentUpdated(el, binding, vnode, oldVnode) {
        // const EXPRESSION = binding?.expression || ''
        const VALUE = binding?.value || ''
        const { src: IMAGE_URL = '', width: IMAGE_WIDTH = '', height: IMAGE_HEIGHT = '' } = VALUE
        el.style.backgroundImage = `url(${setPicSize(IMAGE_URL)})`
        el.style.width = `${toRealPx(IMAGE_WIDTH)}px`
        el.style.height = `${toRealPx(IMAGE_HEIGHT)}px`
        el.style.backgroundPosition = 'center'
        el.style.backgroundSize = 'cover'
        el.style.backgroundRepeat = 'no-repeat'
      }
    })
    /**
     * v-anchor
     * 定位到相对元素top的位置
     */
    Vue.directive('anchor', {
      bind(el, bind) {
        const placeholder = document.createElement('div')
        placeholder.className = bind?.value?.className || ''
        placeholder.style.top = (bind?.value?.top || 0) + 'px'
        placeholder.style.position = 'absolute'
        placeholder.style.width = '0px'
        placeholder.style.height = '0px'
        el.style.position = 'relative'
        el && el.append(placeholder)
      }
    })
  }
}
